import * as types from './actionTypes';

export function updateNestedFieldSelectorData(dataToBeUpdated) {
  return {
    type: types.UPDATE_NESTED_FIELD_SELECTOR_DATA,
    dataToBeUpdated,
  };
}

export function resetNestedFieldSelectorData() {
  return {
    type: types.RESET_NESTED_FIELD_SELECTOR_DATA,
  };
}
